import { Component } from 'js-component-framework';
import { Popup } from 'aria-components';
import fastdom from 'fastdom';

/**
 * MenuButton component.
 */
export default class MenuButton extends Component {
  /**
   * Set classnames to trigger manue animations.
   *
   * @static
   *
   * @param {boolean} state.expanded The current Popup state.
   */
  static onStateChange({ expanded }) {
    const globalHeader = document.querySelector('.global-header');

    fastdom.mutate(() => {
      if (expanded) {
        globalHeader.classList.add('mega-menu--animating-in');
        globalHeader.classList.remove('mega-menu--animating-out');
      } else {
        globalHeader.classList.add('mega-menu--animating-out');
        globalHeader.classList.remove('mega-menu--animating-in');
      }
    });
  }

  /**
   * Create a new MenuButton.
   *
   * @constructor
   */
  constructor(config) {
    super(config);

    // Bind class methods.
    this.setMenuPopup = this.setMenuPopup.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.handleTransitions = this.handleTransitions.bind(this);

    /**
     * The menu button target.
     *
     * @type {HTMLElement}
     */
    const targetId = this.element.getAttribute('target');
    this.target = document.getElementById(targetId);

    if (null !== this.target) {
      this.setMenuPopup();
    }
  }

  /**
   * Set the menu button popup.
   */
  setMenuPopup() {
    this.target.addEventListener('transitionend', this.handleTransitions);

    this.popup = new Popup({
      controller: this.element,
      target: this.target,
      onStateChange: this.constructor.onStateChange,
    });

    const close = this.target.querySelector('.mega-menu__close');
    close.addEventListener('click', this.hideMenu);

    window.addEventListener('hashchange', this.popup.hide, false);
  }

  /**
   * Hide the menu.
   */
  hideMenu() {
    this.popup.hide();
    this.element.focus();
  }

  /**
   * Handle CSS transition events.
   */
  handleTransitions() {
    const { expanded } = this.popup.getState();
    const globalHeader = document.querySelector('.global-header');

    globalHeader.classList.remove('mega-menu--animating-out');
    globalHeader.classList.remove('mega-menu--animating-in');

    if (expanded) {
      globalHeader.classList.add('mega-menu--open');
    } else {
      globalHeader.classList.remove('mega-menu--open');
    }
  }
}
